import React, { useRef, useEffect, useState } from 'react';
import { mockData } from '../data/mock';
import { ChevronRight } from 'lucide-react';

const Media = () => {
  const scrollContainerRef = useRef(null);
  const [mediaItems, setMediaItems] = useState([]);

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  // Scroll to top on page load and fetch media
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchMedia = async () => {
      try {
        const response = await fetch(`${API_URL}/api/media`);
        if (response.ok) {
          const data = await response.json();
          setMediaItems(data);
        }
      } catch (error) {
        console.log('Using fallback mock data');
        setMediaItems(mockData.mediaHub);
      }
    };
    fetchMedia();
  }, [API_URL]);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }
  };

  return (
    <div className="media-page">
      <section className="media-banner-section grunge-texture">
        <div className="media-banner-image">
          <img 
            src="/media-banner.png" 
            alt="Dream Sports Foundation Media"
            className="media-banner-img"
          />
        </div>
      </section>

      <section className="media-full-section grunge-texture">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-2">Latest Updates</h2>
            <div className="scroll-controls">
              <button onClick={scrollLeft} className="scroll-btn" aria-label="Scroll left">
                <ChevronRight size={24} style={{ transform: 'rotate(180deg)' }} />
              </button>
              <button onClick={scrollRight} className="scroll-btn" aria-label="Scroll right">
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
          <div className="media-scroll-container" ref={scrollContainerRef}>
            {(mediaItems.length > 0 ? mediaItems : mockData.mediaHub).map((item) => (
              <a key={item.id} href={item.external_link || item.url} className="media-card" target="_blank" rel="noopener noreferrer">
                <div className="media-image-wrapper">
                  <img 
                    src={
                      item.image_url?.startsWith('/api') 
                        ? `${API_URL}${item.image_url}` 
                        : (item.image_url || item.image)
                    } 
                    alt={item.title} 
                    className="media-image" 
                  />
                </div>
                <div className="media-content">
                  <h3 className="heading-6">{item.title}</h3>
                  <span className="caption">{new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;